import React from 'react';
import { connect } from 'react-redux'
import { message } from 'antd';
import { SIOC } from '../../const/C';
import { subsetByLang, getLangValue, updateTripletsByObjectValue } from '../../virtuoso/helper';
import { WikiActions, AdmsAsset, RdfTriplet } from '../../redux';
import { WikiPageListItem } from './WikiPageSmall';
import { getLastSectionPath, makeDescription, makeIRIPage, makeURL } from './helper';


/** Отображение ссылки на wiki статью
 * 1. Заголовок - название wiki вики статьи или URL (если ссылка на информацию о wiki ещё не считана). 
 * 2. Тело - обрезаное содержимое статьи
 * 
 * Входным прараметром является URI на wiki статью в liferay
 * */
class WikiLink extends React.Component {
  state = {
    page: "?????",
    loading: false,
  }
  
  componentDidMount() {
    this.parserURL();
    //this.loadDetails();
  }

  /** Парсинг URL, так как может быть wiki задана в анонимном узле */
  parserURL(){
    const {triplet, content, wiki} = this.props;
    if (triplet && triplet.o.type =="bnode")
        if (content && content.results && Array.isArray(content.results.bindings)){
          const bnodes = content.results.bindings.filter( item => item.s.value == wiki);
          //console.log("WikiLink.js parserURL()", bnodes);
          if (bnodes.length>0){
            const page = bnodes.filter(item => item.p.value == SIOC.PREDICAT_LINK);
            //console.log("WikiLink.js parserURL()", page);
            if (page.length>0){
              this.setState({page: page[0].o.value});          
              return;
            }
          }
        }
    this.setState({page: wiki});
  }

  loadDetails(items=null) {
    // const {wikies, lang, graph, onLoadDetailWikies} = this.props;
    // this.setState({loading: true});
    // const values = (items)?items:wikies;
    // //Получаем список ссылок
    // const data = subsetByLang(values, lang);
    // const requests = data.map(wiki => RdfTriplet.loadSubject(wiki.object.value, graph));
    // //Получим описание всех элементов и обновим wiki
    // Promise.all(requests).then(result => {
    //    result.forEach(wiki => {
    //       //определим исходный источник, т.к. нужно указать в параметрах lang, для которого нужно сделать обновление
    //       const sources = data.filter(item => item.object.value == wiki.subject);
    //       const findLang = (sources && (sources.length>0))? getLangValue(sources[0]): undefined;
    //       updateTripletsByObjectValue({values: wiki.bindings, state: "loaded"}, values, wiki.subject, findLang);
    //    });
    //    onLoadDetailWikies(AdmsAsset, values);
    //    this.setState({loading: false});
    // }).catch( e => {
    //   data.forEach(wiki => {
    //     updateTripletsByObjectValue({state: "error"}, values, wiki.object.value);
    //   });
    //   onLoadDetailWikies(AdmsAsset, values);
    //   this.setState({loading: false});
    //   message.error(`Ошибка при получении дополнительной информации и распространении элемента каталога. ${e}`)
    // })
  };
    
  onAction (e, type, item) {
    // e.preventDefault();
    // console.log("onAction (e, type, item)", e, type, item);
    // this.props.onLoadNodes()
    //   .then(response => {
    //     console.log("result", response);
    //     this.setState({modal:"add"});
    //   })
    //   .catch(e => {
    //     message.error(`Ошибка при поиске статей. ${e}`); 
    //   });
  };
    
  render() {
    //console.log(this);
    const { page } = this.state;
    //const { wiki } = this.props;
    return (
      <span><a href={page} target="_blank">{decodeURIComponent(getLastSectionPath(page))}</a></span>
    );
  }
}

//Представление информации о Wiki статьях
export default connect(
  (state, props) => {
    const { vset } = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
    })
  },
  dispatch => ({
    onLoadDetailWikies (actions, values){
      return dispatch(actions.LOAD_WIKIES(values));
    },
  })
)(WikiLink)
